import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[appResponsive]'
})
export class ResponsiveDirective {
  @HostBinding('class.mobile') mobileClass: boolean = false;

  constructor(el: ElementRef) {
    addEventListener('resize', () => this.mobileClass = screen.width < 500)
    this.mobileClass = screen.width < 500
  }
}
